import { ProjectTeamEmailMode } from 'generated/graphql';
import { TagColor } from '@spotted-zebra-uk/ui-components';

export const TOOLTIP_CONTENT = {
  [ProjectTeamEmailMode.AssigneeBased]:
    'Only assignees are notified when their candidates assessments are complete.',
  [ProjectTeamEmailMode.AccessBased]:
    'All hiring team members with access to a candidate are notified when their assessments are complete.',
  [ProjectTeamEmailMode.ProjectRoleBased]:
    'Only hiring team members with specified hiring roles will be notified when candidates complete their assessments.',
  [ProjectTeamEmailMode.ProjectRoleAndAssigneeBased]:
    'Only specified hiring roles within the hiring team, assignees, or both will be notified when candidates complete their assessments.',
  [ProjectTeamEmailMode.Disabled]:
    'No notifications will be sent when candidates complete their assessments.',
};

export const MODE_TAG_COLOR = {
  [ProjectTeamEmailMode.AssigneeBased]: TagColor.BLUE,
  [ProjectTeamEmailMode.AccessBased]: TagColor.PURPLE,
  [ProjectTeamEmailMode.ProjectRoleBased]: TagColor.GREEN,
  [ProjectTeamEmailMode.ProjectRoleAndAssigneeBased]: TagColor.RED,
  [ProjectTeamEmailMode.Disabled]: TagColor.YELLOW,
};
